import { Col, Container, Row } from 'react-bootstrap';
import CHARITIES from './charitiesData';
import './CharitiesList.css';

type Props = { embedded?: boolean };

function CharitiesList({ embedded = false }: Props) {
  const content = (
    <>
      <div className="section-head charities-head">
        <h2>Charities We Have Supported</h2>
        <p className="charities-intro">
          Through your support of our fundraisers, Council 1056 has been proud to support these
          organizations over the years.
        </p>
      </div>
      <Row as="ul" className="list-unstyled g-3 mb-0">
        {CHARITIES.map((c) => (
          <Col as="li" xs={12} sm={6} lg={4} xl={3} key={c.name}>
            {c.url ? (
              <a
                className="charity-card charity-card-link"
                href={c.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${c.name} (opens in a new tab)`}
              >
                <span className="charity-name">{c.name}</span>
                <span className="charity-ext" aria-hidden="true">&#8599;</span>
              </a>
            ) : (
              <div className="charity-card">
                <span className="charity-name">{c.name}</span>
              </div>
            )}
          </Col>
        ))}
      </Row>
    </>
  );

  if (embedded) {
    return (
      <div className="charities-embedded mb-4" id="charities">
        {content}
      </div>
    );
  }

  return (
    <section className="section charities-section" id="charities">
      <Container>{content}</Container>
    </section>
  );
}

export default CharitiesList;